// extracted by mini-css-extract-plugin
module.exports = {"wrap_div":"TeamRequestsManage_wrap_div__1sgX7","content_div":"TeamRequestsManage_content_div__17ze5","teamRequests_table":"TeamRequestsManage_teamRequests_table__A5402"};